import { render, staticRenderFns } from "./EmailSwipes.vue?vue&type=template&id=77a124f4&"
import script from "./EmailSwipes.vue?vue&type=script&lang=js&"
export * from "./EmailSwipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports